import { render, staticRenderFns } from "./UserInfoAndSettings.vue?vue&type=template&id=247f65a7&scoped=true&"
import script from "./UserInfoAndSettings.vue?vue&type=script&lang=js&"
export * from "./UserInfoAndSettings.vue?vue&type=script&lang=js&"
import style0 from "./UserInfoAndSettings.vue?vue&type=style&index=0&id=247f65a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247f65a7",
  null
  
)

export default component.exports